import React from "react";
import "./Footer.css"; // Ensure this path is correct
export default function Footer() {}
